import { useControllableValue, useCreation } from 'ahooks';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { pickDomAttrs } from '../_util/utils';
import { useConfig } from '../hooks/useConfig';
import Tooltip from '../tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const INPUT_TAB_KEY = 'ZEN_DESIGN_TAB_SELECT_INPUT';
const TabSelect = props => {
  const {
    locale: {
      TabSelect: TabSelectLocale
    }
  } = useConfig();
  const {
    size = 'm',
    options,
    disabled,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-tab-select");
  const attrs = pickDomAttrs(restProps);
  const [value, setValue] = useControllableValue(props);
  const [activeItemKey, setActiveItemKey] = useState();
  const [inputValue, setInputValue] = useState('');
  const [inputTouched, setInputTouched] = useState(false);
  const inputFocusedRef = useRef(false);
  const _options = useCreation(() => {
    var _options$flatMap;
    let inputCount = 0;
    const _options = (_options$flatMap = options === null || options === void 0 ? void 0 : options.flatMap(item => {
      if (item.type === 'input') {
        inputCount++;
        if (inputCount > 1) {
          return [];
        }
      }
      return [item];
    })) !== null && _options$flatMap !== void 0 ? _options$flatMap : [];
    if (inputCount > 1) {
      console.error('[TabSelect] input 类型的 option 最多只能存在一个');
    }
    return _options;
  }, [options]);
  const children = useCreation(() => {
    return _options.map((item, idx) => {
      const key = item.type === 'input' ? INPUT_TAB_KEY : item.value;
      const isActive = activeItemKey === key;
      const isDisabled = !!item.disabled || !!disabled;
      const onSelect = v => {
        if (!isDisabled && !isActive) {
          setActiveItemKey(key);
          setValue(v);
        }
      };
      const eleProps = {
        key: item.type === 'input' ? INPUT_TAB_KEY : item.value,
        className: classNames("".concat(baseClassName, "-item"), {
          active: isActive,
          disabled: isDisabled
        }),
        style: {
          width: item.width
        },
        onClick: () => {
          if (item.type !== 'input') {
            onSelect(item.value);
          }
        }
      };

      // input item
      if (item.type === 'input') {
        let error = undefined;
        if (isActive) {
          var _item$rules;
          if (inputValue && inputTouched) {
            // 如果输入的值是某个disabled选项的值，展示错误信息
            _options.findIndex(it => {
              if (it.type !== 'input' && it.disabled && it.value.toString() === inputValue) {
                error = "".concat(it.value).concat(TabSelectLocale.disabled);
                return true;
              }
              return false;
            });
          }
          if (!error && (_item$rules = item.rules) !== null && _item$rules !== void 0 && _item$rules.length && inputTouched) {
            var _item$rules$find;
            error = (_item$rules$find = item.rules.find(r => !r.validator(inputValue))) === null || _item$rules$find === void 0 ? void 0 : _item$rules$find.message;
          }
        }
        return /*#__PURE__*/_jsx("div", {
          ...eleProps,
          className: classNames(eleProps.className, "".concat(baseClassName, "-item--input"), {
            error: !!error
          }),
          children: /*#__PURE__*/_jsx(Tooltip, {
            open: !!error,
            title: error || item.tooltip,
            getPopupContainer: triggerNode => triggerNode.parentNode,
            children: /*#__PURE__*/_jsx("div", {
              className: "".concat(baseClassName, "-item--inner"),
              children: /*#__PURE__*/_jsx("input", {
                type: "text",
                disabled: isDisabled,
                placeholder: item.placeholder,
                value: inputValue,
                onChange: e => {
                  let v = e.target.value;
                  if (typeof item.onInput === 'function') {
                    const res = item.onInput(v);
                    if (typeof res === 'string') {
                      v = res;
                    } else if (res === false) {
                      return;
                    }
                  }
                  setInputValue(v);
                  setValue(v);
                  if (!inputTouched) {
                    setInputTouched(true);
                  }
                },
                onFocus: e => {
                  onSelect(e.target.value);
                  inputFocusedRef.current = true;
                },
                onBlur: () => {
                  inputFocusedRef.current = false;
                  setInputTouched(true);
                }
              })
            })
          })
        });
      }

      // 普通 item
      return /*#__PURE__*/_jsx("div", {
        ...eleProps,
        className: classNames(eleProps.className, "".concat(baseClassName, "-item--basic")),
        children: /*#__PURE__*/_jsx(Tooltip, {
          title: item.tooltip,
          getPopupContainer: triggerNode => triggerNode.parentNode,
          children: /*#__PURE__*/_jsx("div", {
            className: "".concat(baseClassName, "-item--inner"),
            children: item.label
          })
        })
      });
    });
  }, [_options, disabled, activeItemKey, inputValue, inputTouched]);
  useEffect(() => {
    if (inputFocusedRef.current) {
      return;
    }
    if (value === undefined || value === null) {
      setActiveItemKey(INPUT_TAB_KEY);
      return;
    }
    let activeItemIdx = _options.findIndex(it => it.type === 'input' ? false : it.value === value);
    if (activeItemIdx >= 0) {
      setActiveItemKey(_options[activeItemIdx].value);
    } else {
      setActiveItemKey(INPUT_TAB_KEY);
      setInputValue(value.toString());
    }
  }, [_options, value]);
  return /*#__PURE__*/_jsx("div", {
    ...attrs.data,
    className: classNames(baseClassName, "".concat(baseClassName, "-size-").concat(size), className),
    style: style,
    children: children
  });
};
export default TabSelect;